import { render, staticRenderFns } from "./medical_follow_new.vue?vue&type=template&id=7854b98b&scoped=true&"
import script from "./medical_follow_new.vue?vue&type=script&lang=js&"
export * from "./medical_follow_new.vue?vue&type=script&lang=js&"
import style0 from "./medical_follow_new.vue?vue&type=style&index=0&id=7854b98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854b98b",
  null
  
)

component.options.__file = "medical_follow_new.vue"
export default component.exports